<template>
    <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                    v-model="dateRangeText"
                    label="Choose the date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker
                no-title
                v-model="date"
                :allowed-dates="allowedDates"
                @change="handleChange"
                scrollable
                range
        ></v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        name: 'Datepicker',
        props: {
            selectedDate: Array,
            allowDates: Array,
            checkDaysDiff: Boolean
        },
        data: function () {
            return {
                date: [],
                menu: false
            }
        },
        methods: {
            allowedDates(val) {
                return this.allowDates.indexOf(val) !== -1

            },
            handleChange(date) {
                let startDate = new Date(date[0]);
                let endDate = new Date(date[1]);
                let diffDate = parseInt((endDate - startDate) / (1000 * 60 * 60 * 24), 10);
                if(startDate > endDate){
                    alert("Finish Date can't be earlier than Start Date");
                    this.date = []
                }else if(this.checkDaysDiff && diffDate > 7){
                    alert('Selected date range must be less than 7 days!');
                    this.date = []
                }else{
                    this.$emit("onChange", date);
                    this.menu = false
                }
            }
        },
        computed: {
            dateRangeText () {
                return this.date.join(' ~ ')
            },
        },
        watch:{
            selectedDate:function(){
                this.date = this.selectedDate
            }
        }
    }
</script>
